export default "<m-cylinder\n    color=\"red\"\n    y=\"2\"\n></m-cylinder>\n";